export default "__VITE_ASSET__BE8mXMHm__"